import React from "react";
import MUIButton from "@mui/material/Button";
import PropTypes from "prop-types";
import clsx from "clsx";

import Label from "components/typographies/Label/Label.component";

// Styles
import { useStyles } from "./Button.styles";

const Button = ({
  variant,
  size,
  labelSize,
  startIcon,
  endIcon,
  children,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <MUIButton
      {...rest}
      className={clsx(
        classes.root,
        classes[variant],
        classes[size],
        rest?.className,
      )}
      variant={variant === "contained" ? variant : undefined}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      <Label size={labelSize}>{children}</Label>
    </MUIButton>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf(["contained", "outlined", "tertiary", "text"]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  labelSize: PropTypes.oneOf(["xs", "sm", "md", "lg"]), // TODO: it would be nice to have a global way to do styles so that I didn't have to steal this .oneOf from Label.component (typescript ;))
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
};

Button.defaultProps = {
  variant: "filled",
  size: "md",
  labelSize: "lg",
  startIcon: undefined,
  endIcon: undefined,
};

export default Button;
